import { isNumber, clamp } from 'lodash';

/**
 * Coverts hours to defined period
 *
 * @param {Number} hours
 * @param {String} period
 * @returns {Number}
 */
function getDifference(hours, period) {
  if (!isNumber(hours)) {
    return;
  }

  const units = {
    month: 24 * 30,
    week: 24 * 7,
    day: 24,
    hour: 1,
  };

  return Math.floor(hours / units[period]);
}

/**
 * Returns the max value for provided range and period
 *
 * @param {String} from
 * @param {String} period
 * @param {String} timezone
 * @returns {Number}
 */
export const getMaxPeriod = (from, period, timezone) => {
  const startDate = moment.tz(from, timezone);
  const endDate = moment.tz(timezone);
  const isBeforeExtendedPeriod = startDate.isBefore(moment.tz('2019-05-01', 'UTC'));
  const limit = {
    day: isBeforeExtendedPeriod ? 30 : 120,
    week: isBeforeExtendedPeriod ? 12 : 52,
    month: Infinity,
  }[period];

  const hours = endDate.diff(startDate, 'hour');
  const difference = getDifference(hours, period);

  return clamp(difference, 0, limit);
};

/**
 * Returns default value for 'cohort_period_filter' based on range and period
 *
 * @param {String} from
 * @param {String} to
 * @param {String} period
 * @returns {String}
 */
export const getDefaultCustomPeriod = (from, period, timezone) => {
  const max = getMaxPeriod(from, period, timezone);

  return `0-${max}`;
};
